<app-page-title></app-page-title>
<div class="table-wrapper">
<p-table [value]="organizationList"
         [tableStyle]="{ 'min-width': '50rem' }"
         styleClass="p-datatable-sm"
         [scrollable]="true"
         scrollHeight="flex"
         [customSort]="true"
         [lazy]="true"
         [resizableColumns]="true"
         columnResizeMode="expand"
         [columns]="tabHeader"
         [reorderableColumns]="true"
         (onLazyLoad)="loadData($event, true)"
         (onColReorder)="saveColumnOrder()">
    <ng-template pTemplate="header">
        <tr>
            <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" pReorderableColumn pResizableColumn>
                <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': ['fullName', 'contactPerson', 'headName'].includes(column.key) ? '15em': '5em'}">
                    {{ column.label }}&nbsp;
                    <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-organization let-columns="columns">
        <tr class="table-content-text">
            <ng-container *ngFor="let col of columns">
            <td class="h10-text black-80" *ngIf="col.key === 'directionId'">
                <div class="flex-12rem">

            <ng-container *ngFor="let direction of organization.directions">
                {{ direction.shortName }}<br><br>
            </ng-container>

                </div>
            </td>
            <td class="h10-text black-60 no-wrap" *ngIf="col.key === 'regionName'">{{organization.regionName}}</td>
            <td class="h10-text black-80" *ngIf="col.key === 'fullName'">
                <div class="flex-12rem">
                    <span class="truncate-text">
                        {{organization.fullName}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-60" *ngIf="col.key === 'edrpou'">{{organization.code}}</td>
            <td class="h10-text black-80" *ngIf="col.key === 'shortName'">
                <div class="flex-12rem">
                    <span class="truncate-text">
                        {{organization.shortName}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-80" *ngIf="col.key === 'actualAddress'">
                <div class="flex-12rem">
                    <span class="truncate-text">
                        {{organization.actualAddress}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-60 truncate" *ngIf="col.key === 'email'">

            </td>
            <td class="h10-text black-80 truncate" *ngIf="col.key === 'headName'">
                <span >{{organization.getHeadFullName()}}</span>
                <br>
                <span class="h10-text black-40">
                    {{ organization.headPhone }}
                </span>
                <br>
                <img *ngIf="organization.getHeadFullName() || organization.headPhone" src="assets/icons/table/copy_to_clipboard.svg" style="cursor: pointer" (click)="copyToClipboard(organization.getHeadFullName() + ' ' + organization.headPhone)">

            </td>
            <td class="h10-text black-80" *ngIf="col.key === 'contactPerson'">
            </td>
            <td class="h10-text black-60" *ngIf="col.key === 'subordinationId'"></td>
            <td class="h10-text black-80" *ngIf="col.key === 'type'">{{organization.type}}</td>
            <td class="h10-text black-80" *ngIf="col.key === 'budgetYear'">{{organization.status}}</td>
        </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary">
        <div class="flex flex-center flex-between">
            <med-pagination
                    [total]="totalRows"
                    [page]="selectedPageNumber"
                    [perPage]="pageSize"
                    (pageChange)="pageChange($event)"
            ></med-pagination>

            <div class="small-text">
                Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRows }}
            </div>

            <med-radio-group
                    mode="buttons"
                    [value]="totalRows"
                    [options]="paginationOptions"
                    (onInput)="pageSizeChanged($event)"
            ></med-radio-group>
        </div>
    </ng-template>
</p-table>
</div>
